window.$crisp = []
window.CRISP_WEBSITE_ID = 'ab79049a-47e5-4fa1-a653-6e44040f45f5';
(function () {
  d = document
  s = d.createElement('script')
  s.src = 'https://client.crisp.chat/l.js'
  s.async = 1
  d.getElementsByTagName('head')[0].appendChild(s)
})()
